@if (config$ | async; as config) {
  <era-devices-state-list-ui [devices]="devices$ | async"
                             [title]="config.title"
                             [emptyMessage]="config.emptyMessage"
                             (selected)="itemSelected($event)">
  </era-devices-state-list-ui>
}